"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 650,
    margin: theme.spacing(0, 'auto')
  }
}));
